query UsageHistory(
  $dateFrom: DateTime!
  $dateTo: DateTime!
  $calendarInterval: CalendarInterval
) {
  usageHistory(
    dateFrom: $dateFrom
    dateTo: $dateTo
    calendarInterval: $calendarInterval
  ) {
    calendarInterval
    items {
      label
      displayCurrency
      data {
        x
        y
      }
    }
  }
}
